import PropTypes from 'prop-types';
import { openNewWindow, facebookShareUrl } from '../../utils';
import RoundButton from '../../components/round-button/RoundButton';
import styles from './shareInProject.module.less';
import Image from '../../components/image/Image';

const FacebookShareButton = ({
    urlToShare,
    trackEventName,
    trackEventFunction,
    buttonClassName,
    logoAsButton = false,
}) => {
    const facebookUrl = facebookShareUrl(urlToShare);

    return (
        <div className={styles.shareComponent}>
            <RoundButton
                onClick={() => {
                    trackEventFunction();
                    openNewWindow(facebookUrl);
                }}
                className={buttonClassName}
                category={trackEventName}
                action="facebook"
                alt="Del på Facebook"
            >
                {logoAsButton ? (
                    <Image className={styles.logo} src="/public/images/fb-logo2.png" height={45} width={45} />
                ) : (
                    <i className="fab fa-facebook-f" title="Del på Facebook">
                        <span className="sr-only">Del på Facebook</span>
                    </i>
                )}
            </RoundButton>
            <div className={styles.shareDescription}>Facebook</div>
        </div>
    );
};

FacebookShareButton.defaultProps = {
    trackEventName: 'share',
    buttonClassName: '',
};

FacebookShareButton.propTypes = {
    urlToShare: PropTypes.string.isRequired,
    trackEventName: PropTypes.string,
    buttonClassName: PropTypes.string,
    trackEventFunction: PropTypes.func,
};

export default FacebookShareButton;
